export const STATUSCONTENT = {
    title: 'Buscá por alguno de los siguientes términos: Teléfono, Email o Nombre'
};

